import { v4 as uuid } from 'uuid'
import { INSIGHT_BLOCK_DEFAULTS } from '../shared/defaults/block-seeds'

export const CHART_TYPES = Object.freeze({
  area: {
    id: 'area',
    label: 'Area Chart',
    desc: 'Continuous trends and volume',
  },
  bar: {
    id: 'bar',
    label: 'Bar Chart',
    desc: 'Categorical comparisons',
  },
  line: {
    id: 'line',
    label: 'Line Chart',
    desc: 'Precise trend plotting',
  },
  pie: {
    id: 'pie',
    label: 'Ring chart',
    desc: 'Proportional distribution',
  },
})

export const CHART_COLORS = [
  '#38bdf8',
  '#818cf8',
  '#a78bfa',
  '#e879f9',
  '#f472b6',
  '#fb7185',
]

export const CHART_MARGIN = Object.freeze({
  top: 18,
  right: 32,
  left: 16,
  bottom: 14,
})

export const X_AXIS_PADDING = Object.freeze({ left: 24, right: 24 })

function normalizeRow(raw) {
  if (!raw || typeof raw !== 'object') return null
  const label =
    typeof raw.label === 'string'
      ? raw.label
      : typeof raw.name === 'string'
        ? raw.name
        : ''
  const value = Number(raw.value)
  return {
    id: typeof raw.id === 'string' ? raw.id : uuid(),
    label,
    value: Number.isFinite(value) ? value : 0,
  }
}

export function normalizeInsightRows(rows) {
  if (!Array.isArray(rows) || !rows.length) {
    return INSIGHT_BLOCK_DEFAULTS.rows.map((r) => ({ ...r, id: r.id || uuid() }))
  }
  return rows.map(normalizeRow).filter(Boolean)
}

/** New chart payload + legacy `insights[]` migration. */
export function normalizeInsightData(raw) {
  if (!raw || typeof raw !== 'object') {
    return {
      chartType: INSIGHT_BLOCK_DEFAULTS.chartType,
      title: INSIGHT_BLOCK_DEFAULTS.title,
      insight: INSIGHT_BLOCK_DEFAULTS.insight,
      rows: normalizeInsightRows(INSIGHT_BLOCK_DEFAULTS.rows),
    }
  }

  if ('chartType' in raw || 'rows' in raw || 'insight' in raw) {
    return {
      chartType:
        raw.chartType && CHART_TYPES[raw.chartType] ? raw.chartType : null,
      title: typeof raw.title === 'string' ? raw.title : '',
      insight: typeof raw.insight === 'string' ? raw.insight : '',
      rows: normalizeInsightRows(raw.rows),
    }
  }

  if (Array.isArray(raw.insights) && raw.insights.length) {
    const first = raw.insights[0]
    const texts = raw.insights
      .map((i) => (typeof i?.text === 'string' ? i.text.trim() : ''))
      .filter(Boolean)
    return {
      chartType: 'bar',
      title:
        typeof first?.title === 'string' && first.title.trim()
          ? first.title.trim()
          : 'Data insight',
      insight: texts.join(' '),
      rows: normalizeInsightRows(INSIGHT_BLOCK_DEFAULTS.rows),
    }
  }

  if (typeof raw.title === 'string' || typeof raw.body === 'string') {
    return {
      chartType: 'bar',
      title: typeof raw.title === 'string' ? raw.title : '',
      insight:
        typeof raw.body === 'string'
          ? raw.body
          : typeof raw.content === 'string'
            ? raw.content
            : '',
      rows: normalizeInsightRows(INSIGHT_BLOCK_DEFAULTS.rows),
    }
  }

  return {
    chartType: INSIGHT_BLOCK_DEFAULTS.chartType,
    title: INSIGHT_BLOCK_DEFAULTS.title,
    insight: INSIGHT_BLOCK_DEFAULTS.insight,
    rows: normalizeInsightRows(INSIGHT_BLOCK_DEFAULTS.rows),
  }
}
